import {
  CONFIRMED_CREATE_RECEPTIONIST_ACTION,
  CONFIRMED_MARK_PATIENT_CURRENT,
  CONFIRMED_GET_RECEPTIONISTS,
  CONFIRMED_ADD_VITALS_ACTION,
  CONFIRMED_COLLECT_PAYMENT_ACTION,
  CONFIRMED_UPCOMING_APPOINTMENT,
  CONFIRMED_GET_AVAILABLE_SLOTS,
  CONFIRMED_RESCHEDULE_APPOINTMENT,
  CONFIRMED_RESCHEDULE_QUEUE_APPOINTMENT,
  CONFIRMED_SEND_FORM_LINK,
  CONFIRMED_PAUSE_DOCTOR_QUEUE,
  CONFIRMED_MARK_PATIENT_EMERGENCY,
  CONFIRMED_MARK_PATIENT_COMPLETE,
  CONFIRMED_GET_BOOKED_APPOINTMENTS,
  FAILED_GET_BOOKED_APPOINTMENTS,
  CONFIRMED_RESCHEDULE_BOOKED_APPOINTMENT,
  FAILED_RESCHEDULE_BOOKED_APPOINTMENT,
  MARK_PATIENT_NEXT_REQUEST,
  MARK_PATIENT_NEXT_SUCCESS,
  MARK_PATIENT_NEXT_FAILURE,
  CONFIRMED_SEND_REMINDER,
  FAILED_SEND_REMINDER,
  CONFIRMED_GET_EMERGENCY_PATIENTS,
  FAILED_GET_EMERGENCY_PATIENTS,
  CONFIRMED_ADD_BACK_TO_QUEUE,
  FAILED_ADD_BACK_TO_QUEUE,
  CONFIRMED_UPLOAD_PATIENT_PHOTO ,
  CONFIRMED_ADD_SEARCH_PATIENT_QUEUE,
  FAILED_ADD_SEARCH_PATIENT_QUEUE
} from "../actions/ReceptionistTypes";
import {
  createReceptionist,
  formatReceptionists,
  getReceptionists,
  markPatientAsCurrent,
  addVitals,
  collectPayment,
  upcomingAppointment,
  getAvailableSlots,
  rescheduleAppointment,
  rescheduleQueueAppointment,
  SendFormLink,
  pauseDoctorQueue,
  markPatientEmergency,
  markPatientComplete,
  bookedAppointments,
  formatBookedAppointments,
  // rescheduleAppointment,
  rescheduleAppointments,
  markPatientNext,
  sendReminder,
  getEmergencyPatients,
  addBackToQueueService,
  uploadPatientPhoto ,
  addSearchPatientQueue
} from "../../services/ReceptionistService";
import swal from "sweetalert";

function getAuthToken(getState) {
  const token = localStorage.getItem("token");
  console.log("token Action ==>", token);
  return token;
}

export function getReceptionistsAction(doctorId, isMulti = "No") {
  return async (dispatch, getState) => {
    try {
      const response = await getReceptionists(doctorId, isMulti);
      if (
        response &&
        response.status === 200 &&
        response.data?.status === "success"
      ) {
        const isGrouped = isMulti === "YES";
        const receptionists = formatReceptionists(
          response.data.data,
          isGrouped
        );
        const isPaused = response.data?.is_pause === "Yes";
        console.log("REC >> ", receptionists);
        dispatch({
          type: CONFIRMED_GET_RECEPTIONISTS,
          payload: {
            receptionists,
            isPaused,
            doctorId,
          },
        });
      } else {
        handleError("Failed to get receptionists: Server error");
      }
    } catch (error) {
      console.error("API Error:", error);
      showErrorAlert("Failed to get receptionists");
    }
  };
}

export function upcomingAppointmentAction(date) {
  return async (dispatch, getState) => {
    try {
      const response = await upcomingAppointment(date);
      if (
        response &&
        response.status === 200 &&
        response.data?.status === "success"
      ) {
        const receptionists = formatReceptionists(response.data.data);
        console.log("REC >> ", receptionists);
        dispatch({
          type: CONFIRMED_UPCOMING_APPOINTMENT,
          payload: receptionists,
        });
      } else {
        handleError("Failed to get receptionists: Server error");
      }
    } catch (error) {
      console.error("API Error:", error);
      showErrorAlert("Failed to get receptionists");
    }
  };
}
export const getEmergencyPatientsAction = () => {
  return async (dispatch) => {
    try {
      const response = await getEmergencyPatients();

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_EMERGENCY_PATIENTS,
          payload: response.data.data,
        });
      } else {
        dispatch({ type: FAILED_GET_EMERGENCY_PATIENTS });
      }
    } catch (error) {
      console.error("Emergency patients error:", error);
      dispatch({ type: FAILED_GET_EMERGENCY_PATIENTS });
    }
  };
};
export function createReceptionistAction(qrcodescanData, doctorId = 0) {
  return async (dispatch) => {
    try {
      const response = await createReceptionist(qrcodescanData, doctorId);
      if (response?.data?.status === "success") {
        console.log( "Create receptionist response:", response);
        dispatch({
          type: CONFIRMED_CREATE_RECEPTIONIST_ACTION,
          payload: response.data.data,
        });
        handleSuccess("Patient added to queue!");
        return response.data.data;
      } else {
        throw new Error(
          response?.messages || "Failed to add patient to queue"
        );
      }
    } catch (error) {
      console.error("Add to queue error:", error);
      showErrorAlert("Failed to add patient to queue");
    }
  };
}

export function markPatientCurrentAction(queue_id) {
  return async (dispatch) => {
    try {
      const response = await markPatientAsCurrent(queue_id);
      if (response?.data?.status === "success") {
        const currentData = response.data.data;
        dispatch({
          type: CONFIRMED_MARK_PATIENT_CURRENT,
          payload: currentData,
        });
        return currentData;
      } else {
        const message =
          response?.data?.message || "Failed to mark patient as current.";
        showErrorAlert(message);
        throw new Error(message);
      }
    } catch (error) {
      console.error("Error marking patient as current:", error);
      showErrorAlert("Could not mark patient as current. Please try again.");
    }
  };
}

export const addSearchPatientQueueAction =
  (    appointment_id = 0,patient_id, doctor_id, time_slot, date,branch_id) => {
    return async (dispatch) => {
      try {
        const response = await addSearchPatientQueue(
          appointment_id,
          patient_id,
          doctor_id,
          time_slot,
          date,
          branch_id
        );
        if (response?.data?.status === "success") {

          dispatch({
            type: CONFIRMED_ADD_SEARCH_PATIENT_QUEUE,
            payload: response.data.data,
          });
        
          return response.data;
        } else {
          showErrorAlert(
            response?.data?.message || "Failed to add patient to queue"
          );
          dispatch({
            type: FAILED_ADD_SEARCH_PATIENT_QUEUE,
          });
        }
      } catch (error) {
        console.error("Add Search Patient Queue Error:", error);
        showErrorAlert("Something went wrong");
        dispatch({
          type: FAILED_ADD_SEARCH_PATIENT_QUEUE,
        });
        throw error;
      }
    };
  };

export const addVitalsAction = (formData) => {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      const vitalsData = {
        queue_id: formData.queue_id,
        weight: formData.weight || "",
        height: formData.height || "",
        bmi: formData.bmi || "",
        pluse_rate: formData.pulseRate || "",
        temperature: formData.temperature || "",
        systolic_bp: formData.systolicBP || "",
        diastolic_bp: formData.diastolicBP || "",
        Oxygen_Saturation: formData.oxygenSaturation || "",
        blood_glucose_level: formData.bloodGlucose || "",
        Allergies: formData.allergies || "",
        Reports_Upload: formData.Reports_Upload || null,

      };
      const response = await addVitals(vitalsData);
      console.log("addvitals ==>", vitalsData);
      dispatch({
        type: CONFIRMED_ADD_VITALS_ACTION,
        payload: response.data?.data || response,
      });
      return response;
    } catch (error) {
      console.error("Error in addVitalsAction:", error.response || error);
      throw error;
    }
  };
};

export const collectPaymentAction = (formData) => {
  return async (dispatch, getState) => {
    console.log("form data >> ", formData);
    try {
      // Build request payload dynamically
      const payload = {
        queue_id: formData.queue_id,
        amount: formData.amount,
        payment_type: formData.payment_type,
        final_amount: formData.final_amount,
        reference_id: formData.reference_id || 0, // Use reference_id if provided, otherwise default to empty string
      };

      // Include patient_id if present, otherwise fallback to lead_id
      if (formData.patient_id) {
        payload.patient_id = formData.patient_id;
      } else if (formData.lead_id) {
        payload.lead_id = formData.lead_id;
      }

      const response = await collectPayment(payload);

      dispatch({
        type: CONFIRMED_COLLECT_PAYMENT_ACTION,
        payload: response.data?.data || response,
      });

      await new Promise((resolve) => setTimeout(resolve, 500));
      await dispatch(getReceptionistsAction(formData.admin_id || 1));
      return response;
    } catch (error) {
      console.error("Error in collectPaymentAction :", error);
      throw error;
    }
  };
};

export const addBackToQueueAction = (queue_id) => {
  return async (dispatch) => {
    try {
      const response = await addBackToQueueService(queue_id);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_ADD_BACK_TO_QUEUE,
          payload: queue_id,
        });

       handleSuccess( "Patient added back to queue!", );

        return response.data;
      } else {
        throw new Error(
          response?.data?.message || "Failed to add back to queue"
        );
      }
    } catch (error) {
      console.error("Add Back To Queue Error:", error);
      showErrorAlert("Error", "Failed to add back to queue", "error");

      dispatch({ type: FAILED_ADD_BACK_TO_QUEUE });
      throw error;
    }
  };
};

export const uploadPatientPhotoAction = (patient_id, file) => {
  return async (dispatch) => {
    try {
      const response = await uploadPatientPhoto(patient_id, file);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_UPLOAD_PATIENT_PHOTO,
          payload: {
            patient_id,
            patient_photo: response.data.data?.patient_photo,
          },
        });

        handleSuccess("Patient photo uploaded successfully!");
      } else {
        showErrorAlert(response?.data?.message || "Failed to upload patient photo");
      }
    } catch (error) {
      console.error("Upload patient photo error:", error);
      showErrorAlert("Failed to upload patient photo");
    }
  };
};
import { removePatient } from "../../services/ReceptionistService";
import {
  handleError,
  handleSuccess,
  showErrorAlert,
} from "../../services/ErrorHandlingService";

export function removePatientAction(patient) {
  return async (dispatch) => {
    try {
      const response = await removePatient(patient.queue_id);
      if (response?.data?.status === "success") {
        handleSuccess("Patient removed successfully!");
        dispatch(getReceptionistsAction());
      } else {
        showErrorAlert(response?.data?.message || "Failed to remove patient");
      }
    } catch (error) {
      console.error("Error removing patient:", error);
      showErrorAlert("Failed to remove patient");
    }
  };
}
// mark as next 
export const markPatientNextAction = (queue_id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: MARK_PATIENT_NEXT_REQUEST,
      });

      const response = await markPatientNext(queue_id);

      if (response?.data?.status === "success") {

        dispatch({
          type: MARK_PATIENT_NEXT_SUCCESS,
          payload: queue_id,
        });

        // handleSuccess("Patient marked as Next");

        // Refresh queue list
        // if (doctor_id) {
        //   dispatch(getReceptionistsAction(doctor_id));
        // }

      } else {
        dispatch({
          type: MARK_PATIENT_NEXT_FAILURE,
        });

        showErrorAlert(response?.data?.message || "Failed to mark next patient");
      }

    } catch (error) {

      dispatch({
        type: MARK_PATIENT_NEXT_FAILURE,
      });

      console.error("Mark Next Error:", error);
      showErrorAlert("Something went wrong");
    }
  };
};

export const sendReminderAction = (appointment_id) => async (dispatch) => {
  try {
    const response = await sendReminder(appointment_id);

    if (response?.data?.status === "success") {
      handleSuccess("Reminder sent successfully!");

      dispatch({
        type: CONFIRMED_SEND_REMINDER,
        payload: appointment_id,
      });
    } else {
      showErrorAlert(response?.data?.message || "Failed to send reminder");

      dispatch({ type: FAILED_SEND_REMINDER });
    }
  } catch (error) {
    console.error("sendReminder error:", error);
    showErrorAlert("Failed to send reminder");

    dispatch({ type: FAILED_SEND_REMINDER });
  }
};

export function getAvailableSlotsAction(
  startDate,
  endDate,
  leadId,
  adminId = 7,
  doctorId = 1,
  patientId
) {
  return async (dispatch) => {
    try {
      const response = await getAvailableSlots(
        startDate,
        endDate,
        leadId,
        adminId,
        doctorId,
        patientId
      );
      if (
        response &&
        response.status === 200 &&
        response.data?.status === "success"
      ) {
        dispatch({
          type: CONFIRMED_GET_AVAILABLE_SLOTS,
          payload: response.data.data,
        });
        return response.data.data;
      } else {
        throw new Error(
          response?.data?.message || "Failed to get available slots"
        );
      }
    } catch (error) {
      console.error("Get available slots error:", error);
      throw error;
    }
  };
}

export function rescheduleAppointmentAction(appointmentData) {
  return async (dispatch) => {
    try {
      const response = await rescheduleAppointment(appointmentData);
      if (
        response &&
        response.status === 200 &&
        response.data?.status === "success"
      ) {
        dispatch({
          type: CONFIRMED_RESCHEDULE_APPOINTMENT,
          payload: response.data,
        });
        return response.data;
      } else {
        throw new Error(
          response?.data?.message || "Failed to reschedule appointment"
        );
      }
    } catch (error) {
      console.error("Reschedule appointment error:", error);
      throw error;
    }
  };
}

export function rescheduleQueueAppointmentAction(queueData) {
  return async (dispatch) => {
    try {
      const response = await rescheduleQueueAppointment(queueData);
      if (
        response &&
        response.status === 200 &&
        response.data?.status === "success"
      ) {
        dispatch({
          type: CONFIRMED_RESCHEDULE_QUEUE_APPOINTMENT,
          payload: response.data,
        });
        return response.data;
      } else {
        throw new Error(
          response?.data?.message || "Failed to reschedule queue appointment"
        );
      }
    } catch (error) {
      console.error("Reschedule queue appointment error:", error);
      throw error;
    }
  };
}

export function sendFormLinkAction(patient_id) {
  return async (dispatch) => {
    try {
      const response = await SendFormLink({ patient_id });
      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_SEND_FORM_LINK,
          payload: response.data.data,
        });
        handleSuccess(
        
           "Form link sent successfully!"
        );
        return response.data;
      } else {
        throw new Error(response?.data?.message || "Failed to send link");
      }
    } catch (error) {
      console.error("Send payment link error:", error);
      showErrorAlert(
        error?.response?.data?.message ||
          "Failed to send form link"
      );
      throw error;
    }
  };
}

export function pauseDoctorQueueAction(doctor_id, is_pause = "Yes") {
  return async (dispatch) => {
    try {
      const response = await pauseDoctorQueue(doctor_id, is_pause);
      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_PAUSE_DOCTOR_QUEUE,
          payload: {
            doctor_id,
            is_pause: is_pause === "Yes",
            message: response.data.message,
          },
        });

        if (is_pause === "Yes") {
          swal(
            "Queue Paused!",
            "The patient queue has been paused successfully!",
            "warning"
          );
        } else {
          swal(
            "Queue Resumed!",
            "The patient queue has been resumed successfully!",
            "success"
          );
        }

        return response.data;
      } else {
        throw new Error(
          response?.data?.message || "Failed to update queue status"
        );
      }
    } catch (error) {
      console.error("Pause/Resume doctor queue error:", error);
      swal("Error", "Failed to update queue status", "error");
      throw error;
    }
  };
}

export function markPatientEmergencyAction(queue_id) {
  return async (dispatch) => {
    try {
      const response = await markPatientEmergency(queue_id);
      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_MARK_PATIENT_EMERGENCY,
          payload: { queue_id, is_emergency: true },
        });
        // swal("Success!", "Patient marked as emergency!", "success");
        return response.data; // 👈 returns response.data, not the full object
      } else {
        throw new Error(
          response?.data?.message || "Failed to mark patient as emergency"
        );
      }
    } catch (error) {
      console.error("Mark patient emergency error:", error);
      swal("Error", "Failed to mark patient as emergency", "error");
      throw error;
    }
  };
}

export function markPatientCompleteAction(queue_id) {
  return async (dispatch) => {
    try {
      const response = await markPatientComplete(queue_id);
      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_MARK_PATIENT_COMPLETE,
          payload: { queue_id, is_complete: true },
        });
        swal( "Patient marked as complete!");
        return response.data; // 👈 returns response.data, not the full object
      } else {
        throw new Error(
          response?.data?.message || "Failed to mark patient as complete"
        );
      }
    } catch (error) {
      console.error("Mark patient complete error:", error);
      swal("Error", "Failed to mark patient as complete", "error");
      throw error;
    }
  };
}

// export function getBookedAppointmentsAction(date ,doctor_id) {
//   return async (dispatch) => {
//     console.log("🔥 ACTION HIT", { date });

//     try {
//       const response = await bookedAppointments(date,doctor_id);
//       console.log("✅ API RESPONSE", response);

//       if (response?.data?.status === "success") {
//         dispatch({
//           type: CONFIRMED_GET_BOOKED_APPOINTMENTS,
//           payload: formatBookedAppointments(response.data.data),
//         });
//       } else {
//         dispatch({ type: FAILED_GET_BOOKED_APPOINTMENTS });
//       }
//     } catch (error) {
//       console.error("❌ API ERROR", error);
//       dispatch({ type: FAILED_GET_BOOKED_APPOINTMENTS });
//     }
//   };
// }
export function getBookedAppointmentsAction(date, doctor_id = null, isPayment = "Yes") {
  return async (dispatch) => {
    try {
      const response = await bookedAppointments(date, doctor_id, isPayment);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_BOOKED_APPOINTMENTS,
          payload: formatBookedAppointments(response.data.data),
          meta: { isPayment, doctorId: doctor_id },
        });
      } else {
        dispatch({ type: FAILED_GET_BOOKED_APPOINTMENTS });
      }
    } catch (error) {
      dispatch({ type: FAILED_GET_BOOKED_APPOINTMENTS });
    }
  };
}
export function rescheduleBookedAppointmentAction(payload) {
  return async (dispatch) => {
    try {
      const response = await rescheduleAppointments(payload);

      if (response?.status === "success") {
        dispatch({
          type: CONFIRMED_RESCHEDULE_BOOKED_APPOINTMENT,
          payload: response,
        });

        return response;
      }

      throw new Error(response?.message || "Reschedule failed");

    } catch (error) {
      dispatch({ type: FAILED_RESCHEDULE_BOOKED_APPOINTMENT });
      throw error;
    }
  };
}
